import { useState } from 'react';

export const useTabs = (numberOfTabs: number) => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const [enabledTabs, setEnabledTabs] = useState<number[]>([0]);

  const completeTab = (tabIndex: number) => {
    if (tabIndex < numberOfTabs - 1) {
      if (!enabledTabs.includes(tabIndex + 1)) {
        setEnabledTabs([...enabledTabs, tabIndex + 1]);
      }
      setActiveTab(tabIndex + 1);
    }
  };

  return { activeTab, enabledTabs, setActiveTab, completeTab, setEnabledTabs };
};
